import React, { useMemo, useState } from 'react';
import {
  View,
  Text,
  ActivityIndicator,
  TouchableOpacity,
  ScrollView,
} from 'react-native';
import { Device, DeviceMode } from '@oolio-group/domain';
import Icon from '../../component/Icon/Icon';
import Search from '../../component/System/Search/Search';
import { styles } from './PairingScreen.styles';
import theme from '../../common/theme';

interface Props {
  loading: boolean;
  devices: Device[];
  onSelect?: (device: Device) => void;
}

const DeviceList: React.FC<Props> = ({
  loading,
  devices,
  onSelect = () => undefined,
}) => {
  const [searchText, onSearch] = useState('');

  const devicesList = useMemo(() => {
    return devices
      .filter(
        device =>
          device.name.toLowerCase().includes(searchText.toLowerCase()) &&
          device.mode === DeviceMode.F_POS,
      )
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [searchText, devices]);

  return (
    <View style={styles.content}>
      <Text style={styles.title}>Select device to continue...</Text>
      <Search
        testID="search"
        maxLength={50}
        onChangeText={onSearch}
        placeholder="Search for devices by name..."
        containerStyle={styles.search}
      />
      {loading ? (
        <View style={styles.loading}>
          <ActivityIndicator size={20} color={theme.palette.primary} />
        </View>
      ) : (
        <View style={styles.table}>
          <ScrollView contentContainerStyle={styles.scrollDevices}>
            {devicesList.length > 0 ? (
              devicesList.map(device => (
                <TouchableOpacity
                  key={device.id}
                  style={styles.rowParent}
                  onPress={() => onSelect(device)}
                >
                  <View style={styles.deviceText}>
                    <Text
                      style={styles.textParent}
                    >{`${device.name} (${device.deviceProfile.name})`}</Text>
                    <Text
                      style={[
                        styles.deviceInfoText,
                        !device.isPaired && styles.deviceInfoTextUnpaired,
                      ]}
                    >
                      {device.isPaired ? device.details : 'Not Paired'}
                    </Text>
                  </View>
                  <Icon name="angle-right" color={theme.palette.mono500} />
                </TouchableOpacity>
              ))
            ) : (
              <View style={styles.loading}>
                <Text style={styles.emptyText}>No devices found.</Text>
              </View>
            )}
          </ScrollView>
        </View>
      )}
    </View>
  );
};

export default DeviceList;
